import CustomDataField from "../models/custom_data_field";

import Collection from "backdraft-app/src/collection";

import _ from "underscore";
import $ from "jquery";

export default class CustomDataFields extends Collection {
  get model() {
    return CustomDataField;
  }

  // Reject custom data fields that are inherited and those that have blank values.
  // Must return hash in the form of:
  // { "custom_data" : { "field1": "value1", "field2": "value2" } }
  toJSON() {
    const validModels = _.reject(this.models, model => (model.get('inherited')) || ($.trim(model.get('fieldValue')) === ""));

    const fields = _.map(validModels, model => model.toJSON());

    const customData = _.extend.apply(_, fields);

    return !_.isEmpty(customData) ? { custom_data: customData } : { custom_data: {} };
  }
}
